export const EVM_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/g;

export const isEvmAddress = (address: string) => {
  return !!address.match(EVM_ADDRESS_REGEX);
};
